import { useSelector, useDispatch } from 'react-redux';
import { setUpdateSessionTTL } from 'redux/reducers/userReducer';
import { timeoutList } from '../utils/timeoutList';
import { MenuItem } from '@mui/material';
import TextFieldRow from 'components/UtilityComponents/Form/TextFieldRow';
import styles from '../branches.module.css';

const TimeSelector = () => {
	const sessionTTL = useSelector((state) => state.user.sessionTTL);
	const dispatch = useDispatch();

	const handleChange = (e) => {
		dispatch(setUpdateSessionTTL(e.target.value));
	};

	const timeoutListMap = timeoutList.map((val) => {
		return val ? (
			<MenuItem key={val.value} value={val.value}>
				{val.label}
			</MenuItem>
		) : null;
	});

	return (
		<div className={styles.timeSelectorWrapper}>
			<div>Idle Session Duration</div>
			<div className={styles.textFieldRowSize}>
				<TextFieldRow
					select
					value={sessionTTL}
					onChange={(e) => handleChange(e)}>
					{timeoutListMap}
				</TextFieldRow>
			</div>
		</div>
	);
};

export default TimeSelector;
